// Phase 14e-1c — operator-facing caregiver lifecycle-transition schemas.
//
// Extracted from caregiver/admin.schema.ts per Convention 06's
// "extraction-as-trigger" rule (Phase 11b banking-admin extraction was
// the first trigger; this is the second to keep the file under cap +
// finish the per-resource split for the caregiver admin domain). Holds
// schemas for activate / suspend / unsuspend / terminate operator
// actions on a caregiver.
import { z } from 'zod';
import { CaregiverStatusSchema } from './application.schema.js';
/** POST /admin/caregivers/:id/activate response.
 *
 *  Success: { ok: true, status: ACTIVE, activatedAt: ... }
 *  Reject:  { ok: false, missing: [...] }   ← 409 with this body
 *
 *  `missing` is a discriminated list like ['credential:NACC',
 *  'compliance:TB_TEST', 'credential:VSC:expired', 'availability:none',
 *  'profile:phone_missing', 'profile:address_incomplete'] so the
 *  operator UI can route to the right "unmet requirement" view.
 *
 *  Phase 5f-d audit r1 — code regex extended to accept the new
 *  `availability:none`, `profile:phone_missing`,
 *  `profile:address_incomplete` codes emitted by
 *  `checkActivationRequirements()`. */
export const AdminActivationMissingRequirementSchema = z.string().regex(/^(credential|compliance):[A-Z_]+(:expired)?$|^availability:none$|^profile:(phone_missing|address_incomplete)$/, 'Missing-requirement codes: "credential:NACC", "compliance:TB_TEST", "availability:none", "profile:phone_missing", "profile:address_incomplete" (credential/compliance codes may have ":expired" suffix)');
export const AdminActivationOkResponseSchema = z.object({
    ok: z.literal(true),
    status: z.literal('ACTIVE'),
    activatedAt: z.string().datetime(),
});
export const AdminActivationMissingResponseSchema = z.object({
    ok: z.literal(false),
    reason: z.literal('missing_requirements'),
    missing: z.array(AdminActivationMissingRequirementSchema),
});
export const AdminSuspendRequestSchema = z.object({
    reason: z.string().min(1).max(2000).trim(),
});
/** Phase 14b-2 post-audit H1 — caregiver unsuspend (SUSPENDED → ACTIVE).
 *  Mirrors facility's `AdminFacilityUnsuspendRequestSchema`. Empty body —
 *  the suspension reason was captured at suspend time + is read-only
 *  history once unsuspend lands. */
export const AdminCaregiverUnsuspendRequestSchema = z.object({}).strict();
export const AdminTerminateRequestSchema = z.object({
    reason: z.string().min(1).max(2000).trim(),
});
/** Lifecycle-transition responses share this shape (when not the
 *  activation-with-missing-requirements case). */
export const AdminCaregiverStatusResponseSchema = z.object({
    id: z.string().uuid(),
    status: CaregiverStatusSchema,
    activatedAt: z.string().datetime().nullable(),
    suspendedAt: z.string().datetime().nullable(),
    suspensionReason: z.string().nullable(),
    terminatedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=lifecycle-admin.schema.js.map